/**
 * Read a cookie by name.
 * @param {string} name - The name of the cookie.
 * @return {string|null} - The value of the cookie or null if not found.
 */
export function getCookie( name ) {
	return document.cookie
	.split( '; ' )
	.map( cookie => cookie.trim() )
	.find( cookie => cookie.startsWith( `${name}=` ) )?.split( '=' )[ 1 ] || null;
}

/**
 * Set a cookie with the given name, value, and expiration days.
 * @param {string} name - The name of the cookie.
 * @param {string} value - The value of the cookie.
 * @param {number} days - The number of days until expiration.
 */
export function setCookie(name, value = '', days) {
	const expires = days ? `; expires=${new Date(Date.now() + days * 864e5).toUTCString()}` : '';
	const domainParts = location.host.split('.').reverse();
	const domain = domainParts.length > 1 ? `; domain=.${domainParts[1]}.${domainParts[0]}` : '';
	document.cookie = `${name}=${value}${expires}${domain}; path=/`;
}

/**
 * Delete a cookie by name.
 * @param {string} name - The name of the cookie to delete.
 */
export function deleteCookie( name ) {
	document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

/**
 * Update the user's status by reading cookies.
 */
export function freshUserStatus() {
	const user = {
		studentId: '',
		cartId: '',
		role: '',
		isLoggedIn: false,
	}

	user.studentId = getCookie( 'STYXKEY-McKissock-UserId' );
	user.cartId = getCookie( 'STYXKEY-shoppingcartid' );
	user.role = getCookie( 'STYXKEY-McKissock-Role' );

	if ( user.studentId && user.role && user.role !== 'Guest' ) {
		user.isLoggedIn = true;
	} else if ( user.role === 'Guest' ) {
		user.isLoggedIn = 'Guest';
	} else {
		user.isLoggedIn = false;
	}
	return user;
}

// Capture cart cookies on partnership group pages
export function registerCookieLogging() {
	const $body = jQuery( 'body' );
	if (
		$body.hasClass( 'retail-group-template' ) ||
		$body.hasClass( 'university-group-template' )
	) {
		$body.one( 'ColibriEvent:DO_ADD_TO_CART_SUCCESS', function() {
			// List of shopping cart cookies
			const cookieNames = [
				'McKissock-LongExpiration',
				'McKissock-Role',
				'McKissock-Token',
				'McKissock-UserId',
				'shoppingcartid',
				'STYXKEY-McKissock-LongExpiration',
				'STYXKEY-McKissock-Role',
				'STYXKEY-McKissock-Token',
				'STYXKEY-McKissock-UserId',
				'STYXKEY-partnershipid',
				'STYXKEY-shoppingcartid',
				'X-Credential',
			];

			// Log cookie values
			cookieNames.forEach( ( item ) => {
				const cookieValue = getCookie( item );
				if ( cookieValue ) {
					console.log( item, ': ', cookieValue );
				} else {
					console.log( item, ': Not Set' );
				}
			} );
		} );
	}
}
